<!-- <template>
  <div class="carbon">
    <vue-particles
      :particleOpacity="0.7"
      :particlesNumber="50"
      shapeType="circle"
      :particleSize="1"
      linesColor="#00FA91"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push">
    </vue-particles>
    <div class="section-3-container scrollable">
      <div class="container">
        <div class="curve-container" ref="curveContainer" style="position: relative;">
          <div class="circle circle_1"></div>
          <div class="circle circle_2"></div>
          <div class="circle circle_3"></div>
          <div class="circle circle_4"></div>
          <div class="circle circle_5"></div>
          <div class="circle circle_6"></div>
          <!-- 上层曲线 -->
          <svg class="color-curve"  viewBox="0 0 1143 5720" fill="none" xmlns="http://www.w3.org/2000/svg" style="z-index: 2;">
            <path id="color-path" d="M295.301 2.49219C319.301 2.49219 1380.55 84.7155 1089.8 225.992C575.3 475.992 373.301 543.492 95.3017 744.992C-321.921 1047.4 786.571 1282.69 1069.3 1713.49C1343.3 2130.99 -79.0117 2561.92 252.301 2988.49C625.502 3468.99 876.001 3779.1 1094 4076.49C1418 4518.49 -487.807 4759.58 433.502 5096.99C896.48 5266.55 532.002 5521.49 603.502 5718.99" stroke="transparent" stroke-width="10"/>
          </svg>

          <!-- 下层曲线 -->
          <svg class="gray-curve" viewBox="0 0 1143 5720" fill="none" xmlns="http://www.w3.org/2000/svg" style="z-index: 1;">
            <path d="M295.301 2.49219C319.301 2.49219 1380.55 84.7155 1089.8 225.992C575.3 475.992 373.301 543.492 95.3017 744.992C-321.921 1047.4 786.571 1282.69 1069.3 1713.49C1343.3 2130.99 -79.0117 2561.92 252.301 2988.49C625.502 3468.99 876.001 3779.1 1094 4076.49C1418 4518.49 -487.807 4759.58 433.502 5096.99C896.48 5266.55 532.002 5521.49 603.502 5718.99" stroke="url(#paint0_linear_4311_528)" stroke-width="5"/>
            <defs>
              <linearGradient id="paint0_linear_4311_528" x1="568.201" y1="2.49219" x2="568.201" y2="5550.49" gradientUnits="userSpaceOnUse">
                <stop stop-color="#00FA91"/>
                <stop offset="1" stop-color="#01ECCD"/>
              </linearGradient>
            </defs>
          </svg>
          
          <!-- 内容节点 -->
          <div class="content-node content-node_view">
            <div class="content-node_view_1">双碳引领</div>
            <div class="content-node_view_2">气候变化下的创新产业文明</div>
            <div class="content-node_view_3">在全球气候危机日益严峻的背景下，我们以AI技术为驱动，引领产业走向零碳未来，构建可持续发展的创新生态。</div>
          </div>
          <div class="content-node content-node_1" data-node="1">
            <div class="content-node_1_text_1">目前，国内政府和企业碳普惠平台已达到</div>
            <div class="content-node_1_text_2">100+</div>
          </div>
          <div class="content-node content-node_1" data-node="2">
            <div class="content-node_1_text_1">各地政府推出的碳普惠机制相关文件多达</div>
            <div class="content-node_1_text_2">134项</div>
          </div>
          <div class="content-node content-node_1" data-node="3">
            <div class="content-node_1_text_1">上海市已发布碳普惠方法学</div>
            <div class="content-node_1_text_2">7个</div>
          </div>
          <div class="content-node content-node_4" data-node="4">
            <div class="content-node_4_text_1">气候危机与行动必要性</div>
            <div class="content-node_4_text_2">全球变暖的严峻影响已从理论预测转化为现实威胁，我们正面临着前所未有的生态与社会经济挑战</div>
          </div>
          <div class="content-node content-node_5" data-node="5">
            <div class="content-node_5_text">生态环境正面临系统性威胁</div>
          </div>
          <div class="content-node content-node_6" data-node="6">
            <img class="content-node_IconImg" src="@/assets/img/home/content-node_img_1.png" alt="">
            <div class="content-node_6_view">
              <div class="content-node_6_text_1">极端气候常态化</div>
              <div class="content-node_6_text_2">飓风、干旱等灾害破坏力持续增强，生态系统修复能力显著下降</div>
            </div>
          </div>
          <div class="content-node content-node_6" data-node="7">
            <img class="content-node_IconImg" src="@/assets/img/home/content-node_img_2.png" alt="">
            <div class="content-node_6_view">
              <div class="content-node_6_text_1">海平面上升危机</div>
              <div class="content-node_6_text_2">沿海生态屏障被侵蚀，淡水资源危机，岛屿国家生存空间被压缩</div>
            </div>
          </div>
          <div class="content-node content-node_6" data-node="8">
            <img class="content-node_IconImg" src="@/assets/img/home/content-node_img_3.png" alt="">
            <div class="content-node_6_view">
              <div class="content-node_6_text_1">海平面上升危机</div>
              <div class="content-node_6_text_2">沿海生态屏障被侵蚀，淡水资源危机，岛屿国家生存空间被压缩</div>
            </div>
          </div>
          <div class="content-node content-node_5" data-node="9">
            <div class="content-node_5_text">社会经济代价日益沉重</div>
          </div>
          <div class="content-node content-node_6" data-node="10">
            <div class="content-node_6_view">
              <div class="content-node_6_text_1 textRight">农业生产受冲击</div>
              <div class="content-node_6_text_2">作物减产与病虫害加剧威胁粮食安全，农业适应性面临挑战</div>
            </div>
            <img class="content-node_IconImg" src="@/assets/img/home/content-node_img_4.png" alt="">
          </div>
          <div class="content-node content-node_6" data-node="11">
            <div class="content-node_6_view">
              <div class="content-node_6_text_1 textRight">公共卫生压力</div>
              <div class="content-node_6_text_2">热射病、传染病扩散等新增压力，医疗资源分配面临挑战</div>
            </div>
            <img class="content-node_IconImg" src="@/assets/img/home/content-node_img_5.png" alt="">
          </div>
          <div class="content-node content-node_6" data-node="12">
            <div class="content-node_6_view">
              <div class="content-node_6_text_1 textRight">基础设施挑战</div>
              <div class="content-node_6_text_2">设计标准与气候现状脱节，维护成本成倍增加，城市韧性建设迫在眉睫</div>
            </div>
            <img class="content-node_IconImg" src="@/assets/img/home/content-node_img_6.png" alt="">
          </div>
          <div class="content-node content-node_6 flex_colum" data-node="13">
            <div class="content-node_childView_1">国际协作框架</div>
            <div class="content-node_childView_2">
              <div>• 科学界划定的升温阈值成为各国减排基准</div>
              <div>• 《巴黎协定》推动缔约方持续提高减排承诺</div>
              <div>• 碳定价、绿色金融等工具加速普及</div>
            </div>
          </div>
          <div class="content-node content-node_4" data-node="14">
            <div class="content-node_4_text_1">低碳行动的全球共识</div>
          </div>
          <div class="content-node content-node_6 flex_colum" data-node="15">
            <div class="content-node_childView_1">中国国家战略</div>
            <div class="content-node_childView_2">
              <div>• 双碳目标纳入国家战略，立法强化目标约束力</div>
              <div>• 建立覆盖重点行业的碳核算体系</div>
              <div>• 地方政府考核纳入低碳要素，形成上下联动治理格</div>
            </div>
          </div>
          <div class="content-node content-node_4" data-node="16">
            <div class="content-node_4_text_1">中国市场与政策现状</div>
            <div class="content-node_4_text_3">作为制造业大国，中国面临能源需求增长与减排目标的双重压力</div>
          </div>
          <div class="content-node content-node_6" data-node="17">
            <img class="content-node_IconImg" src="@/assets/img/home/content-node_img_7.png" alt="">
            <div>
              <div class="content-node_6_title">转型挑战</div>
              <div class="content-node_6_titleInfo">• 能源需求增长与减排目标的双重压力</div>
              <div class="content-node_6_titleInfo">• 传统高耗能产业转型需突破技术瓶颈</div>
              <div class="content-node_6_titleInfo">• 千万级就业人口转移的社会成本</div>
            </div>
          </div>
          <div class="content-node content-node_6" data-node="18">
            <div class="textRight">
              <div class="content-node_6_title line_height_100">转型机遇<img class="content-node_IconImg" src="@/assets/img/home/content-node_img_8.png" alt=""></div>
              <div class="content-node_6_titleInfo margin_right_40">• 新能源产业迎来爆发式增长</div>
              <div class="content-node_6_titleInfo margin_right_60">• 风光发电成本已具竞争优势，储能技术突破电网灵活性提升</div>
              <div class="content-node_6_titleInfo margin_right_80">• 碳资产开发培育出新商业模式企业可通过碳汇交易获取额外收益</div>
            </div>
          </div>
          <div class="content-node content-node_6" data-node="19">
            <img class="content-node_IconImg" src="@/assets/img/home/content-node_img_9.png" alt="">
            <div>
              <div class="content-node_6_title">国际碳壁垒</div>
              <div class="content-node_6_titleInfo">• 全球绿色贸易规则重塑竞争格局</div>
              <div class="content-node_6_titleInfo">• 碳边境调节机制倒逼生产工艺升级</div>
              <div class="content-node_6_titleInfo">• 国内碳市场扩容，政策工具日趋精细化</div>
            </div>
          </div>
          <div class="content-node content-node_4" data-node="20">
            <div class="content-node_4_text_1">企业碳管理：从被动合规到主动增值</div>
          </div>
          <div class="content-node content-node_4 flex_center" data-node="21">
            <div>
              <div class="data-node21_text_1">政府端痛点</div>
              <div class="data-node21_text_2">碳管理政策体系存在标准不统一、执行落地难、监管乏力等系统性短</div>
            </div>
            <img class="content-node_IconImg" src="@/assets/img/home/content-node_img_10.png" alt="">
            <img class="content_noed_icon" src="@/assets/img/home/content-node_img_icon.png" alt="">
          </div>
          <div class="content-node content-node_4 flex_center width_700" data-node="22">
            <img class="content_noed_icon" src="@/assets/img/home/content-node_img_icon.png" alt="">
            <img class="content-node_IconImg" src="@/assets/img/home/content-node_img_11.png" alt="">
            <div class="textLeft">
              <div class="data-node21_text_1">企业端困境</div>
              <div class="data-node21_text_2">高碳行业改造成本挤压利润，核心技术存在代际差距，碳管理水平低下</div>
            </div>
          </div>
          <div class="content-node content-node_4 flex_center width_700" data-node="23">
            <img class="content_noed_icon" src="@/assets/img/home/content-node_img_icon.png" alt="">
            <img class="content-node_IconImg" src="@/assets/img/home/content-node_img_11.png" alt="">
            <div class="textLeft">
              <div class="data-node21_text_1">个人端阻力</div>
              <div class="data-node21_text_2">生活习惯固化与低碳消费溢价形成阻力，公众认知仍处初级阶段</div>
            </div>
          </div>
          <div class="content-node content-node_4 flexCenter" data-node="24">
            <div class="flexCenter_text1">引领双碳变革，共建零碳未来</div>
            <div class="flexCenter_text2">面对气候危机的严峻挑战，让我们携手用AI技术开启碳中和的创新之路</div>
          </div>
          <div class="content-node content-node_4 flexCenterBtn" data-node="25">
            <div class="flexCenterBtn_view">了解AI解决方案</div>
            <div class="flexCenterBtn_view">ABOUT US</div>
          </div>
        </div>
        <Footer pageType="carbon" />
      </div>
    </div>
  </div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
import Footer from '@/components/footer/index.vue'

// 注册GSAP插件
gsap.registerPlugin(ScrollTrigger, MotionPathPlugin)

export default {
  components: {
    Footer
  },
  data() {
    return {
      scrollHandlers: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.adjustCurveElements();
      this.initAnimations();
      window.addEventListener('resize', this.adjustCurveElements);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustCurveElements);
  },
  methods: {
    adjustCurveElements() {
      const container = this.$refs.curveContainer;
      if (!container) return;      
      
      // 内容节点位置 - 从左侧开始
      const nodePositions = [
        { left: 13, top: -1.5 }, 
        { left: 69, top: 5.5 },  
        { left: 60, top: 7 },
        { left: 54, top: 8.5 },
        { left: 24, top: 13},
        { left: 28, top: 18 },
        { left: 35, top: 19 },
        { left: 45, top: 20.5 },
        { left: 53, top: 22 },
        { left: 24, top: 22},
        { left: 18, top: 23},
        { left: 26, top: 24.5},
        { left: 28, top: 26},
        { left: 13, top: 32},
        { left: 25, top: 38},
        { left: 60, top: 41},
        { left: 35, top: 51},
        { left: 45, top: 55},
        { left: 7, top: 58},
        { left: 56, top: 60},
        { left: 18, top: 71},
        { left: 35, top: 74},
        { left: 50, top: 80},
        { left: 33, top: 83},
        { left: 25, top: 92},
        { left: 25, top: 96},
      ];
      
      document.querySelectorAll('.content-node').forEach((node, index) => {
        const pos = nodePositions[index];
        node.style.left = `${pos.left}%`;
        node.style.top = `${pos.top}%`;
      });
    },

    initAnimations() {
        // 获取元素
        const colorPath = document.getElementById('color-path');
        const curveContainer = this.$refs.curveContainer;
        const contentNodes = document.querySelectorAll('.content-node');      
        if (!colorPath || !curveContainer) return;
        
        // 计算曲线总长度
        const pathLength = colorPath.getTotalLength();
        
        // 设置描边动画的基础属性
        colorPath.style.strokeDasharray = pathLength;
        colorPath.style.strokeDashoffset = pathLength;
        
        // 获取父级滚动容器
        const scrollContainer = this.findScrollContainer(curveContainer);
        
        if (!scrollContainer) {
            return;
        }
        
        // 确保滚动容器有足够的滚动空间
        if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) {
            return;
        }
        
        // 计算每个节点在线段路径上的位置
        const nodePathPositions = this.calculateNodePathPositions(contentNodes, colorPath, curveContainer);
        
        // 记录上一次的显示长度，用于检测回退
        let lastDisplayedLength = 0;
        
        ScrollTrigger.create({
            trigger: curveContainer,
            scroller: scrollContainer,
            start: 'top 45%',
            end: 'bottom 100%',
            scrub: true,
            onUpdate: (self) => {
                const progress = self.progress;
                
                // 计算当前应该显示的曲线长度
                const displayedLength = pathLength * progress;
                colorPath.style.strokeDashoffset = pathLength - displayedLength;
                
                // 控制内容节点显示 - 基于路径位置
                contentNodes.forEach((node, index) => {
                    const nodePathPosition = nodePathPositions[index];
                    if (!nodePathPosition) return;
                    
                    // 计算当前显示位置与节点路径位置的距离
                    const distanceToNode = displayedLength - nodePathPosition.pathLength;
                    
                    // 检查曲线是否已经到达节点位置
                    const hasReachedNode = displayedLength >= nodePathPosition.pathLength;
                    
                    // 计算显示强度 - 使用更直接的方法
                    let opacity = 0;
                    
                    if (hasReachedNode) {
                        // 曲线已经到达或超过节点位置 - 立即完全显示
                        opacity = 1;
                    } else {
                        // 曲线还未到达节点位置
                        const distanceBeforeNode = nodePathPosition.pathLength - displayedLength;
                        
                        // 设置更小的提前显示阈值（0.5%），让节点几乎与曲线同步显示
                        const earlyShowThreshold = pathLength * 0.005;
                        
                        if (distanceBeforeNode <= earlyShowThreshold) {
                            // 在阈值范围内平滑显示
                            opacity = Math.min(1, (earlyShowThreshold - distanceBeforeNode) / earlyShowThreshold);
                        }
                    }
                    
                    // 应用透明度
                    node.style.opacity = opacity;
                });
            }
        });
    },

    // 新增方法：计算每个节点在线段路径上的位置
    calculateNodePathPositions(contentNodes, path, container) {
        const pathLength = path.getTotalLength();
        
        // 使用更简单直接的方法：基于节点在容器中的垂直位置计算路径位置
        const containerRect = container.getBoundingClientRect();
        const containerHeight = containerRect.height;
        
        return Array.from(contentNodes).map((node) => {
            const nodeRect = node.getBoundingClientRect();
            
            // 计算节点在容器中的垂直位置百分比
            const nodeTop = nodeRect.top - containerRect.top;
            const nodePositionPercent = nodeTop / containerHeight;
            
            // 根据垂直位置百分比计算对应的路径长度
            // 假设路径长度与垂直位置成正比
            const pathLengthAtNode = pathLength * nodePositionPercent;
            
            // 确保路径长度在有效范围内
            const clampedPathLength = Math.max(0, Math.min(pathLength, pathLengthAtNode));
            
            return {
                pathLength: clampedPathLength,
                distance: 0 // 简化计算，不计算实际距离
            };
        });
    },

    findScrollContainer(element) {
      let parent = element.parentElement;
      while (parent) {
        // 检查是否有scrollable类（这是Home.vue中设置的）
        if (parent.classList && parent.classList.contains('scrollable')) {
          return parent;
        }
        
        // 检查CSS overflow属性
        const style = window.getComputedStyle(parent);
        if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
          return parent;
        }
        
        // 检查是否是section-3-container
        if (parent.classList && parent.classList.contains('section-3-container')) {
          return parent;
        }
        
        parent = parent.parentElement;
      }
      return window;
    },
  }
}
</script>

<style lang="scss" scoped>
.carbon{
  background-color: #fff;
  height: 100vh;
  width: 100%;
  position: relative;
  overflow: hidden;

  .vue-particles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .section-3-container {
    width: 100%;
    height: 100vh;
    transition: all 0.3s ease;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    min-height: 100vh;
    padding-top:300px;

    &.scrollable {
      overflow-y: auto!important;
      overflow-x: hidden;
      height: 100vh;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    .container {
      max-width: none;
      margin: 0; 
      padding: 0; 
      width: 100vw;

      .curve-container {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: center;
        max-width: 100vw;
        height: 6000px;
        overflow: visible;

        .circle {
          position: absolute;
          width: 0;
          height: 0;
          background: transparent;
          backdrop-filter: blur(10px);
          box-shadow: 
            0 0 100px 50px rgba(0, 250, 145, 0.02),
            0 0 200px 100px rgba(0, 250, 145, 0.02),
            0 0 300px 150px rgba(0, 250, 145, 0.03),
            0 0 400px 200px rgba(0, 250, 145, 0.02),
            0 0 500px 250px rgba(0, 250, 145, 0.03),
            0 0 600px 300px rgba(0, 250, 145, 0.02);
        }

        .circle_1{
          top: 20px;
          left: 200px;
        }

        .circle_2{
          top: 900px;
          right: 200px;
        }

        .circle_3{
          top: 2100px;
          left: 350px;
        }

        .circle_4{
          top: 3400px;
          right: 700px;
        }

        .circle_5{
          top: 4400px;
          left: 500px;
        }

        .circle_6{
          top: 5500px;
          right: 500px;
        }

        /* 曲线SVG容器 */
        .gray-curve, .color-curve {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: visible;
        }

        .gray-curve path {
          stroke: #00fa91;
          stroke-width: 5;
          fill: none;
          stroke-linecap: round;
        }

        .color-curve path {
          stroke: transparent;
          stroke-width: 2;
          fill: none;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-dasharray: 1;
          stroke-dashoffset: 1;
        }

        /* 内容节点 */
        .content-node {
          position: absolute;
          z-index: 9999;
          opacity: 0;
          display: flex;

          .content-node_IconImg{
            width: 100px;
            height: 100px;
          }

          .content_noed_icon{
            width: 105px;
            height: 15px;
          }

          .textLeft{
            text-align: left!important;
            width: 500px!important;
          }

          .textRight{
            text-align: right;
          }

          .content-node_childView_1{
            width: 350px;
            height: 85px;
            border-radius: 20px;
            background: linear-gradient(180deg, rgba(0, 250, 145, 0.2) 0%, rgba(0, 244, 176, 0.2) 100%);
            backdrop-filter: blur(4px);
            box-shadow: 0px -2px 1px 0px #97C1FF66 inset;
            box-shadow: 0px 11.39px 22.34px 0px #356AB917;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 36px;
            font-weight: 700;
            color: rgba(45, 110, 114, 1);
            border: 1px solid linear-gradient(180deg, rgba(0, 250, 145, 0.5) 0%, rgba(0, 244, 176, 0.5) 100%);
          }

          .content-node_childView_2{
            width: 680px;
            height: 225px;
            border-radius: 20px;
            background: linear-gradient(137.47deg, rgba(255, 255, 255, 0.3) 11.08%, rgba(248, 250, 255, 0.8) 39.07%, rgba(245, 248, 255, 0.9) 60.7%, rgba(255, 255, 255, 0.2) 95.9%);
            box-shadow: 9.25px 13.75px 2px 0px rgba(125, 186, 255, 0.13);
            backdrop-filter: blur(1px);
            box-shadow: 0.75px 3px 7.7px 0px rgba(234, 209, 255, 0.43) inset;
            box-shadow: -1px -3.25px 9.07px 0px rgba(255, 255, 255, 1) inset;
            display: flex;
            justify-content: center;
            flex-direction: column;
            font-size: 28px;
            font-weight: 300;
            color: rgba(40, 144, 160, 1);
            padding-left: 20px;
            margin-top: 20px
          }
        }

        .content-node_view{
          display: flex;
          flex-direction: column;
          justify-content: center;
          opacity: 1;
          position: absolute;
          width: 790px;
          top:370px;
          left: 215px;

          .content-node_view_1{
            font-size: 96px;
            font-weight: 700;
            color: rgba(31, 100, 104, 1);
          }

          .content-node_view_2{
            font-size: 64px;
            font-weight: 400;
            color: rgba(45, 110, 114, 1);
          }

          .content-node_view_3{
            font-size: 24px;
            line-height: 42px;
            font-weight: 400;
            color: rgba(40, 144, 160, 1);
            margin-top:50px;
          }
        }

        .content-node_1{
          display: flex;
          flex-direction: column;
          justify-content: center;

          .content-node_1_text_1{
            font-size: 24px;
            font-weight: 400;
            color: rgba(45, 110, 114, 1);
            letter-spacing: 2px;
          }

          .content-node_1_text_2{
            font-size: 32px;
            font-weight: 700;
            color: rgba(40, 144, 160, 1);
            letter-spacing: 3px;
          }
        }

        .content-node_4{
          display: flex;
          flex-direction: column;
          justify-content: center;

          .content-node_4_text_1{
            font-size: 64px;
            font-weight: 700;
            color: rgba(31, 100, 104, 1);
            letter-spacing: 5px;
            font-family: 'Inter';
          }

          .content-node_4_text_2{
            font-size: 28px;
            font-weight: 400;
            width: 975px;
            color: rgba(45, 110, 114, 1);
            letter-spacing: 3px;
            font-family: 'Regular';
          }

          .content-node_4_text_3{
            font-size: 28px;
            font-weight: 300;
            width: 888px;
            color: rgba(45, 110, 114, 1);
            letter-spacing: 2px;
            padding-left:40px;
            font-family: 'Inter';
          }
        }

        .content-node_5{
          display: flex;
          flex-direction: column;
          justify-content: center;

          .content-node_5_text{
            font-size: 32px;
            font-weight: 700;
            color: rgba(45, 110, 114, 1);
            letter-spacing: 5px;
            font-family: 'Inter';
          }
        }

        .content-node_6{
          display: flex;
          justify-content: center;
          
          .content-node_6_title{
            font-size: 36px;
            font-weight: 700;
            color: rgba(74, 162, 176, 1);
            letter-spacing: 3px;
            font-family: 'Inter';
          }

          .line_height_100{
            display: flex;
            align-items: center;
            justify-content: end;
          }

          .content-node_6_titleInfo{
            font-size: 28px;
            font-weight: 300;
            color: rgba(74, 162, 176, 1);
            letter-spacing: 3px;
            font-family: 'Inter';
          }

          .margin_right_40{
            margin-right: -40px;
          }

          .margin_right_60{
            margin-right: -90px;
          }

          .margin_right_80{
            margin-right: -130px;
          }

          .content-node_6_view{
            display: flex;
            flex-direction: column;
            justify-content: center;
            color: rgba(40, 144, 160, 1);

            .content-node_6_text_1{
              font-size: 24px;
              font-weight: 600;
              font-family: 'Semibold';
            }

            .content-node_6_text_2{
              font-size: 20px;
              font-weight: 400;
              font-family: 'Regular';
            }
          }
        }

        .flex_colum{
          flex-direction: column!important;
        }

        .flex_center{
          align-items: center;
          justify-content: space-between!important;
          flex-direction: row!important;
          width: 780px;
          text-align: right;

          .data-node21_text_1{
            font-size: 36px;
            font-weight: 700;
            color: rgba(45, 110, 114, 1);
            letter-spacing: 2px;
          }

          .data-node21_text_2{
            font-size: 28px;
            font-weight: 300;
            color: rgba(40, 144, 160, 1);
            letter-spacing: 2px;
          }
        }

        .flexCenter{
          align-items: center;
          justify-content: center!important;
          text-align: center;
          flex-direction: column!important;
          left: 50%!important;
          width: 100%;
          transform: translateX(-50%);

          .flexCenter_text1{
            font-size: 64px;
            font-weight: 700;
            color: rgba(31, 100, 104, 1);
            letter-spacing: 4px;
          }

          .flexCenter_text2{
            font-size: 36px;
            font-weight: 300;
            color: rgba(45, 110, 114, 1);
            letter-spacing: 2px;
            line-height: 126px;
          }
        }

        .flexCenterBtn{
          width: calc(100% - 930px);
          justify-content: space-between;
          align-items: center;
          flex-direction: row!important;

          .flexCenterBtn_view{
            width: 350px;
            height: 85px;
            width: 351;
            border-radius: 100px;
            background: linear-gradient(180deg, rgba(0, 250, 145, 0.2) 0%, rgba(0, 244, 176, 0.2) 100%);
            border: 1px solid;
            border-image-source: linear-gradient(180deg, rgba(0, 250, 145, 0.5) 0%, rgba(0, 244, 176, 0.5) 100%);
            backdrop-filter: blur(4px);
            box-shadow: 0px 11.39px 22.34px 0px rgba(53, 106, 185, 0.09);
            font-weight: 700;
            font-size: 36px;
            letter-spacing: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: rgba(40, 144, 160, 1);
            cursor: pointer;
          }
        }

        .width_700{
          width: 700px!important;
        }

        // .content-node_7{
        //   display: flex;
        //   justify-content: center;

        //   .content-node_7_img{
        //     width: 76px;
        //     height: 76px;
        //   }

        //   .content-node_6_view{
        //     display: flex;
        //     flex-direction: column;
        //     justify-content: center;
        //     color: rgba(40, 144, 160, 1);

        //     .content-node_6_text_1{
        //       font-size: 24px;
        //       font-weight: 600;
        //       font-family: 'Semibold';
        //     }

        //     .content-node_6_text_2{
        //       font-size: 20px;
        //       font-weight: 400;
        //       font-family: 'Regular';
        //     }
        //   }
        // }
      }
    }
  }
}
</style> -->